<template>
  <AppFileUploadFilder :filder="file"
                       :filder-name="fileName"
                       :filder-progress="file.progress"
                       :filder-status="file.status"
                       @cancelPendingFilder="onCancelPendingFile"
                       @cancelInProgressFilder="onCancelInProgressFile"
                       @redoFilder="onRedoFile"
  />
</template>

<script>
import { mapActions } from 'vuex'

import AppFileUploadFilder from '@/common/app-file-upload/AppFileUploadFilder.vue'
import { fileNameWithoutExtension } from '@/common/utils/files'
import { AppUploadHandlerActionTypes } from '@/store/modules/app-upload-handler/action_types'

export default {
  name: 'AppFileUploadFile',
  components: { AppFileUploadFilder },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fileName () {
      return fileNameWithoutExtension(this.file.fileObject.name)
    },
  },
  methods: {
    ...mapActions('appUploadHandler', [AppUploadHandlerActionTypes.CANCEL_FILE, AppUploadHandlerActionTypes.REDO_FILE_UPLOAD]),
    onCancelPendingFile () {
      this.CANCEL_FILE(this.file.key)
    },
    onCancelInProgressFile () {
      this.file.cancelToken.cancel()
    },
    onRedoFile () {
      this.REDO_FILE_UPLOAD(this.file.key)
    },
  },
}
</script>
